<div class="confirmation-dialog">
  <div class="dialog-header">
    <h4 class="dialog-title">
      <i class="bi" [ngClass]="getIcon()" [class]="getIconClass()"></i>
      {{ data.title }}
    </h4>
  </div>

  <div class="dialog-body">
    <p>{{ data.message }}</p>
  </div>

  <div class="dialog-footer">
    <button type="button"
            class="btn btn-secondary"
            (click)="onCancel()">
      {{ data.cancelText }}
    </button>
    <button type="button"
            class="btn"
            [ngClass]="getConfirmButtonClass()"
            (click)="onConfirm()">
      {{ data.confirmText }}
    </button>
  </div>
</div>
